<template>
  <div class="modal is_small is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title"></p>
        <button class="delete" aria-label="close" @click="close()"></button>
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-12 has-text-centered">
            Configura las columnas que deseas ver en la lista de servicios
          </div>
          <div class="column is-4" v-for="column in columns" :key="column.id">
            <label class="checkbox" @change="setActiveColumn(column.id)">
              <input type="checkbox" :checked="column.selected">
              {{column.header}}
            </label>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
      <button
        :disabled="loading"
        class="button button_ibs_outlined is-rounded sm_btn"
        type="reset"
        @click="close"
      >
        Cancelar
      </button>
      <button
        class="button button_ibs is-rounded sm_btn"
        :class="{'is-loading': loading}"
        :disabled="loading"
        type="button"
        @click="confirmConfig"
      >
        Guardar
      </button>
    </footer>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ModalColumns',
  data () {
    return {
      columns: [
        {
          id: 'reference',
          header: 'Referencia Interna',
          class: 'column-mobile',
          accessor: (row) => `${row.reference}`,
          link: true,
          type: 'link',
          route: (row) => ({ name: 'detalle-servicio', params: { serviceId: row.id } }),
          selected: false
        },
        { id: 'serviceName', header: 'Servicio', class: 'is-hidden-mobile', selected: false },
        { id: 'providerName', header: 'Proveedor', class: 'column-mobile is-hidden-touch', selected: false },
        { id: 'po_number', header: 'PO', class: 'is-hidden-mobile', selected: false },
        { id: 'container_number', header: 'No. Contenedor', class: 'column-mobile is-hidden-touch', selected: false },
        { id: 'inspection_date', header: 'Fecha Inspección', class: 'is-hidden-mobile', accessor: (row) => moment(row.inspection_date).format('DD-MM-YYYY'), selected: false },
        { id: 'month', header: 'Mes', class: 'column-mobile is-hidden-touch', selected: false },
        { id: 'invoice_number', header: 'No. de Factura', class: 'column-mobile', selected: false },
        { id: 'invoice_amount', header: 'Monto Factura', class: 'column-mobile', selected: false },
        { id: 'country_ccounting', header: 'País', class: 'column-mobile', selected: false }
        // { id: 'config', name: 'config', header: 'Estatus', class: 'is-hidden-mobile' },
        // { id: 'action', name: 'action', header: 'Acciones', class: 'has-text-centered' }
      ],
      loading: false,
      lastPosition: 0
    }
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      default: () => {}
    },
    saveColumns: {
      type: Function,
      default: () => {}
    },
    columnsList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    setActiveColumn (id) {
      const checkColumn = this.columns.find(column => column.id === id)
      if (checkColumn) {
        checkColumn.selected = !checkColumn.selected
        checkColumn.lastPosition = checkColumn.selected ? this.lastPosition + 1 : this.lastPosition - 1
        this.lastPosition = checkColumn.selected ? this.lastPosition + 1 : this.lastPosition - 1
      }
    },
    async confirmConfig () {
      this.loading = true
      const setActiveColumns = this.columns.filter(column => column.selected)
      await this.saveColumns(setActiveColumns)
      this.loading = false
    }
  },
  beforeMount () {
    this.columns = this.columns.map(col => {
      const validateConfig = this.columnsList.find(colList => colList.id === col.id)
      const lastPos = this.columnsList.find(colList => colList.id === col.id && colList.lastPosition)
      this.lastPosition = this.lastPosition <= (lastPos ? lastPos.lastPosition : 0) ? (lastPos ? lastPos.lastPosition : 0) : this.lastPosition
      return { ...col, selected: !!validateConfig, lastPosition: lastPos ? lastPos.lastPosition : 0 }
    })
  }

}
</script>

<style lang="scss" scoped>
  h1 {
    font-size: 24px;
    font-weight: 600;
    line-height: 1.29;
    letter-spacing: 0.72px;
    text-align: center;
    color: #5d6990;
    margin-bottom: 3rem;
  }
  .image_check {
    max-width: 80px;
    margin-bottom: 3rem;
  }
</style>
